import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["children", "onRequestClose", "isOpened", "className", "position", "dismissOnOutsideClick", "hideOverlayDismiss", "scrollable", "compact"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Portal } from 'react-portal';
import './styles.sass';

/**
 * The actual modal.
 */
var ActualModal = /*#__PURE__*/function (_React$Component) {
  function ActualModal() {
    var _this;
    _classCallCheck(this, ActualModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ActualModal, [].concat(args));
    _this.close = function () {
      if (_this.props.onRequestClose) {
        _this.props.onRequestClose();
      }
    };
    return _this;
  }
  _inherits(ActualModal, _React$Component);
  return _createClass(ActualModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        position = _this$props.position,
        dismissOnOutsideClick = _this$props.dismissOnOutsideClick,
        hideOverlayDismiss = _this$props.hideOverlayDismiss,
        scrollable = _this$props.scrollable,
        compact = _this$props.compact;
      return /*#__PURE__*/React.createElement("div", {
        className: cx('Modal', !scrollable && 'no-scroll', 'modal', 'is-active', className, "Modal--".concat(position))
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-background",
        onClick: function onClick() {
          if (dismissOnOutsideClick) {
            _this2.close();
          }
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: cx('modal-container', compact && 'compact')
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, children)), !hideOverlayDismiss && /*#__PURE__*/React.createElement("button", {
        className: "modal-close",
        onClick: this.close
      }));
    }
  }]);
}(React.Component);
ActualModal.propTypes = {
  isControlled: PropTypes.bool,
  className: PropTypes.string,
  onRequestClose: PropTypes.func,
  closePortal: PropTypes.func,
  children: PropTypes.node,
  position: PropTypes.oneOf(['center', 'top']),
  dismissOnOutsideClick: PropTypes.bool,
  hideOverlayDismiss: PropTypes.bool,
  scrollable: PropTypes.bool,
  compact: PropTypes.bool
};

/**
 * A nice Modal component.
 *
 * Simple usage: <Modal openByClickOn={<button>lol</button>}>content</Modal>
 */
var Modal = /*#__PURE__*/function (_React$Component2) {
  function Modal() {
    _classCallCheck(this, Modal);
    return _callSuper(this, Modal, arguments);
  }
  _inherits(Modal, _React$Component2);
  return _createClass(Modal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        onRequestClose = _this$props2.onRequestClose,
        isOpened = _this$props2.isOpened,
        className = _this$props2.className,
        _this$props2$position = _this$props2.position,
        position = _this$props2$position === void 0 ? 'center' : _this$props2$position,
        _this$props2$dismissO = _this$props2.dismissOnOutsideClick,
        dismissOnOutsideClick = _this$props2$dismissO === void 0 ? true : _this$props2$dismissO,
        _this$props2$hideOver = _this$props2.hideOverlayDismiss,
        hideOverlayDismiss = _this$props2$hideOver === void 0 ? false : _this$props2$hideOver,
        _this$props2$scrollab = _this$props2.scrollable,
        scrollable = _this$props2$scrollab === void 0 ? true : _this$props2$scrollab,
        _this$props2$compact = _this$props2.compact,
        compact = _this$props2$compact === void 0 ? false : _this$props2$compact,
        other = _objectWithoutProperties(_this$props2, _excluded);
      return /*#__PURE__*/React.createElement(Portal, other, isOpened && /*#__PURE__*/React.createElement(ActualModal, {
        onRequestClose: onRequestClose,
        isControlled: isOpened !== undefined,
        position: position,
        className: className,
        dismissOnOutsideClick: dismissOnOutsideClick,
        hideOverlayDismiss: hideOverlayDismiss,
        scrollable: scrollable,
        compact: compact
      }, children));
    }
  }]);
}(React.Component);
Modal.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onRequestClose: PropTypes.func,
  isOpened: PropTypes.bool,
  position: PropTypes.oneOf(['center', 'top']),
  dismissOnOutsideClick: PropTypes.bool,
  hideOverlayDismiss: PropTypes.bool,
  compact: PropTypes.bool
};
export default Modal;
//# sourceMappingURL=index.js.map
